import React from 'react';
import ConfirmDialog from '../../../shared/components/ConfirmDialog';

interface Props {
  open: boolean;
  /** Named together, because this is also opened from a list of runs. */
  runTitle: string;
  stepLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
}

// One home for what retrying a step does and what it is called, asked from the open run and from
// a sidebar row. Both name the step and the run: inside the full view one run fills the screen,
// but launched from a list neither is obvious, and the two surfaces drifting apart is how the
// same act ends up described two ways.
const WorkflowRetryDialog: React.FC<Props> = ({
  open,
  runTitle,
  stepLabel,
  onCancel,
  onConfirm,
}) => (
  <ConfirmDialog
    open={open}
    title={`Retry ${stepLabel} in ${runTitle}?`}
    onCancel={onCancel}
    onConfirm={onConfirm}
    confirmText="Retry step"
    confirmColor="warning"
  >
    {`'${stepLabel}' goes back to not started and the run is unblocked. ` +
      'The agent is told to try it again.'}
  </ConfirmDialog>
);

export default WorkflowRetryDialog;
